import BillMultiple from './MultipleSelectActions/BillMultiple'
import ConfirmMultiple from "./MultipleSelectActions/ConfirmMultiple";

export default class MultipleSelect {
  constructor(vueEl) {
    this._vueEl = vueEl
    this._vueEl.$root.$on('selection.deselectAll', () => this._vueEl.checkedTasks = [])
    this._vueEl.$root.$on('selection.bill', () => this.multiAction(new BillMultiple()))
    this._vueEl.$root.$on('selection.confirm', () => this.multiAction(new ConfirmMultiple()))
  }

  isChecked (task) {
    return this._vueEl.checkedTasks.includes(task)
  }

  toggleCheck (task) {
    if (task, this._vueEl.checkedTasks.includes(task)){
      this._vueEl.checkedTasks.splice(this._vueEl.checkedTasks.indexOf(task), 1)
      this._vueEl.$root.$emit('selection.taskDeselected')
    } else {
      this._vueEl.checkedTasks.push(task)
      this._vueEl.$root.$emit('selection.taskSelected')
    }
  }

  multiAction(action) {
    const tasks = this._vueEl.checkedTasks.filter(task => task.done_confirmed === 0)
    if (tasks.length)
      action.act(tasks, this._vueEl, () => this._vueEl.$root.$emit('selection.actionCompleted'))
    else
      this._vueEl.$root.$emit('selection.actionCompleted')
  }
}



// WEBPACK FOOTER //
// ./src/views/agenda/MultipleSelect.js